import styled from "styled-components";

export const AddCompanyMissionV2FormStyled = styled.div`
  .header_section {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    gap: 16px;
    position: relative;
  }

  .back_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: 8px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    flex-shrink: 0;
    margin-right: auto;

    &:hover {
      background: ${({ theme }) => theme.COLORS.GRAY_8};
    }
  }

  .header_title {
    position: absolute;
    left: 50%;
    top: 70%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .header_title .title_th {
    font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
    font-size: ${({ theme }) => theme.FONT.SIZE.S24};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
  }

  .header_title .title_en {
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S20};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    margin-top: 2px;
  }

  .header_save_wrap {
    flex-shrink: 0;
    min-width: 36px;
    display: flex;
    justify-content: flex-end;
  }

  .section_block {
    margin-bottom: 48px;
  }

  .section_header {
    margin-bottom: 12px;
  }


  .row_2col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    align-items: start;
  }

  .row_2col_inner {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    align-items: start;
  }

  .row_4col {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    align-items: start;
  }

  @media (max-width: 1024px) {
    .row_2col,
    .row_2col_inner {
      grid-template-columns: 1fr;
    }

    .row_4col {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 640px) {
    .row_4col {
      grid-template-columns: 1fr;
    }
  }

  .date_range_row {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }

  .date_range_row .date_range_field {
    flex: 1;
    min-width: 140px;
  }

  .date_range_row .between_label {
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
  }

  .dropdown_with_icon {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .dropdown_with_icon .type_icon_preview {
    display: flex;
    align-items: center;
    min-height: 32px;
  }

  .goal_target_row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    align-items: start;
  }

  @media (max-width: 1024px) {
    .goal_target_row {
      grid-template-columns: 1fr;
    }
  }

  .target_amount_cell {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .target_amount_cell .unit_badge {
    margin-top: 8px;
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.GRAY_4};
  }


  .bottom_delete_only {
    display: flex;
    width: 140px;
    justify-content: flex-start;
  }

  .stack_gap {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .team_registration_row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
  }

  .team_registration_summary {
    margin: 0;
    display: flex;
    gap: 4px;
    margin-right: auto;
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
    white-space: nowrap;
  }
  .header_block{
    margin-bottom: 32px;
  }
    
  .header_actions {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .progress_section {
    padding: 32px;
    margin: 20px 0px;
    border-radius: 12px;
    border: 1px solid #e6e6e7;
    background: #fff;
  }

  .progress_code_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
  }

  .progress_code_row .code_label {
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    color: ${({ theme }) => theme.COLORS.GRAY_4};
  }

  .progress_code_row .code_value {
  margin-left: 12px;
    font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
    font-size: ${({ theme }) => theme.FONT.SIZE.S20};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
  }

  .progress_code_row .status_area {
    display: flex;
    align-items: center;
    gap: 22px;
  }

  .progress_code_row .status_text {
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
  }

  .progress_code_row .status_value {
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
  }

  .progress_code_row .status_link {
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    text-decoration: underline;

    &:hover {
      opacity: 0.85;
    }
  }

  .progress_cards_container {
    margin-bottom: 24px;
  }

  .progress_cards_row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  .progress_cards_row > div {
    padding: 0 17px;
    border-right: 1px solid #e6e6e7;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      border-right: none;
      padding-right: 0;
    }
  }

  .progress_info_section {
    display: grid;
    grid-template-columns: 3fr 1fr;
    gap: 32px;
    border-top: 1px solid #e6e6e7;
    padding-top: 24px;
  }

  .info_left {
    display: flex;
    flex-direction: column;
    gap: 26px;
    border-right: 1px solid #e6e6e7;
    padding-right: 32px;
  }

  @media (max-width: 1024px) {
    .progress_cards_row {
      grid-template-columns: 1fr;
      gap: 24px;
    }

    .progress_cards_row > div {
      padding: 0;
      border-right: none;
      border-bottom: 1px solid #e6e6e7;
      padding-bottom: 16px;

      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
      }
    }

    .progress_info_section {
      grid-template-columns: 1fr;
    }

    .info_left {
      border-right: none;
      padding-right: 0;
      border-bottom: 1px solid #e6e6e7;
      padding-bottom: 24px;
    }
  }

`;
